import React from "react";

/*
 * Official Mindteck logo (transparent PNG from Mindteck Workspace Central).
 * tone: "auto" follows the theme (recolored white on dark backgrounds),
 *       "light" forces the white version (for the dark-green login panel),
 *       "dark"  forces the original green + gold colours.
 * variant "mark" renders the compact SVG monogram instead.
 */
const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/mindteck-logo.png`;

export default function Logo({
    size = 26,
    variant = "full",
    tone = "auto",
    showWordmark = true,
    className = "",
}) {
    if (variant === "mark") {
        return (
            <span className={`sm-logo-mark ${className}`} aria-label="Mindteck">
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                >
                    <defs>
                        <linearGradient id="sm-lm-g" x1="6" y1="6" x2="58" y2="58">
                            <stop stopColor="#1E7A57" />
                            <stop offset="0.55" stopColor="#14543C" />
                            <stop offset="1" stopColor="#0E3A29" />
                        </linearGradient>
                        <linearGradient id="sm-lm-gold" x1="14" y1="46" x2="50" y2="46">
                            <stop stopColor="#D9BE78" />
                            <stop offset="1" stopColor="#A8884A" />
                        </linearGradient>
                    </defs>
                    <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#sm-lm-g)" />
                    <rect x="2.75" y="2.75" width="58.5" height="58.5" rx="15.25" stroke="#fff" strokeOpacity="0.16" strokeWidth="1.5" />
                    <path d="M16 44V20L32 36L48 20V44" stroke="#F4F7F4" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14 50C24 47.5 40 47.5 50 50" stroke="url(#sm-lm-gold)" strokeWidth="3.5" strokeLinecap="round" />
                </svg>
            </span>
        );
    }

    return (
        <span className={`sm-logo ${className}`}>
            <img
                src={LOGO_SRC}
                alt="Mindteck"
                className={`mindteck-logo-img tone-${tone}`}
                style={{ height: size }}
                draggable="false"
            />
            {showWordmark && (
                <>
                    <span className="sm-logo-divider" aria-hidden="true" />
                    <span className="sm-logo-text">
                        <span className="sm-logo-title">Skill Management</span>
                    </span>
                </>
            )}
        </span>
    );
}
